import PeopleAvatarCell from './people_avatar_cell';

export default PeopleAvatarCell;
